var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Modal, Heading } from '@kiwicom/orbit-components/lib/';
import { Col } from 'react-grid-system';
import { Button } from '@appspotr/ui-kit';
var ConfirmationPopUp = /** @class */ (function (_super) {
    __extends(ConfirmationPopUp, _super);
    function ConfirmationPopUp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isVisible: false,
        };
        _this.UIActions = {
            modal: {
                show: function () {
                    _this.setState({ isVisible: true });
                },
                hide: function () {
                    _this.setState({ isVisible: false });
                    _this.props.onHide();
                },
                onConfirmation: function () {
                    _this.props.onConfirmation();
                    _this.setState({ isVisible: false });
                    _this.props.onHide();
                },
            },
        };
        return _this;
    }
    ConfirmationPopUp.prototype.componentDidMount = function () {
        if (this.props.isVisible) {
            this.UIActions.modal.show();
        }
        else {
            this.UIActions.modal.hide();
        }
    };
    ConfirmationPopUp.prototype.componentDidUpdate = function (PrevProps) {
        if (PrevProps.isVisible !== this.props.isVisible) {
            if (this.props.isVisible) {
                this.UIActions.modal.show();
            }
            else {
                this.UIActions.modal.hide();
            }
        }
    };
    ConfirmationPopUp.prototype.render = function () {
        return this.state.isVisible ? (_jsx(Modal, __assign({ onClose: this.props.onHide }, { children: _jsxs("div", __assign({ className: "flex flex-1 flex-col justify-center p-10" }, { children: [_jsx(Col, __assign({ lg: 6 }, { children: _jsx(Heading, __assign({ type: "title2" }, { children: this.props.title })) })), _jsxs("div", __assign({ className: "flex flex-1 flex-row justify-end pt-10" }, { children: [_jsx(Button, __assign({ onClick: this.UIActions.modal.hide, style: { width: 200, justifyContent: 'center' }, type: "outline" }, { children: "Cancel" })), _jsx(Button, __assign({ type: "primary", onClick: this.UIActions.modal.onConfirmation, style: { marginLeft: 10, width: 200, justifyContent: 'center' } }, { children: "Confirm" }))] }))] })) }))) : null;
    };
    return ConfirmationPopUp;
}(React.Component));
export default ConfirmationPopUp;
